import React, {useEffect, useRef, useState} from 'react';
import {Button, Grid, IconButton, OutlinedInput, Stack, Typography} from "@mui/material";
import Selected from "../selected/Selected";
import TextInput from "../TextInput/TextInput";
import MyDivider from "../MyDivider/MyDivider";
import {useNavigate} from "react-router-dom";
import {addNewEventApi, getPlanListApi, updateEventApi} from "../../../api/AdminApi";
import {successMessage} from "../../../tools/messages";
import DatePicker, {DateObject} from "react-multi-date-picker";
import {faToEnNum, fixStringToTextView, sleep} from "../../../tools/helper";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import Loading from "../../Site/Loading/Loading";
import {useDispatch} from "react-redux";
import {useImageBrowser} from "../../../hoc/useImageBrowser";
import {SetState} from "../../../redux/reduxhelper";
import {BLOCK_FETCHING} from "../../../redux/action/type.action";
import ImageDeleteModal from "./ImageDeleteModal";
import FlexGrid from "../flexGrid/FlexGrid";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import DeleteIcon from "@mui/icons-material/Delete";

const Event = ({item = {}, callbackFun = undefined}) => {
    const [eventData, setEventData] = useState(item)
    const [planList, setPlanList] = useState([])
    const navigate = useNavigate();

    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const [image3, setImage3] = useState(null);
    const [image4, setImage4] = useState(item?.image_url ?? null);
    const [imageToDelete, setImageToDelete] = useState(null);
    const [deleteFunc, setDeleteFunc] = useState(undefined);

    const dispatch = useDispatch();

    const [imageBrowser1] = useImageBrowser(async (result) => {
        // await console.log(result.blobFile)
        dispatch(SetState(BLOCK_FETCHING, true));
        await console.log(result.blobSrc)
        setImage1(result?.blobFile)
        imageRef1.current.src = result.blobSrc;
        await sleep(3000);
        dispatch(SetState(BLOCK_FETCHING, false));
    })

    const [imageBrowser2] = useImageBrowser(async (result) => {
        // await console.log(result.blobFile)
        await console.log(result.blobSrc)
        setImage2(result?.blobFile)
        imageRef2.current.src = result.blobSrc;
    })

    const [imageBrowser3] = useImageBrowser(async (result) => {
        // await console.log(result.blobFile)
        await console.log(result.blobSrc)
        setImage3(result?.blobFile)
        imageRef3.current.src = result.blobSrc;
    })

    const [imageBrowser4] = useImageBrowser(async (result) => {
        await setImage4({...result})
        imageRef4.current.src = result.blobSrc;
    })
    const imageRef1 = useRef(null)
    const imageRef2 = useRef(null)
    const imageRef3 = useRef(null)
    const imageRef4 = useRef(null)


    const onSubmitHandler = async () => {
        try {

            let {title1, title2, start_date, id: event_id, plan_id, description} = {...eventData};
            let data = new FormData();
            data.append("main_image", image4?.blobFile)
            data.append("title1", title1)
            data.append("title2", title2)
            data.append("start_date", start_date)
            data.append("event_id", event_id)
            data.append("plan_id", plan_id)
            data.append("description", description)

            eventData?.id ? await updateEventApi(data) : await addNewEventApi(data)
            successMessage('با موفقیت انجام شد');
            navigate('/admin/dashboard/events')
        } catch (e) {

        }
    }


    const getPlan = async () => {
        const res = await getPlanListApi()
        setPlanList([{id: 0, name: '---'}, ...res?.data?.data]);
    }


    useEffect(() => {
        getPlan()
    }, [])


    const calendarUi = <DatePicker
        value={faToEnNum(eventData?.start_date)}
        className="rmdp-mobile"
        calendar={persian}
        locale={persian_fa}
        currentDate={
            new DateObject({
                calendar: persian,
                date: eventData?.start_date,
            })
        }
        onChange={(e) => {
            let newDate = (e?.year + '/' + e?.month + '/' + e?.day);
            setEventData({...eventData, start_date: newDate})
        }}
        render={(value, openCalendar) => {
            console.log('new date', value?.toString())
            return (<IconButton onClick={openCalendar}><CalendarTodayOutlinedIcon/></IconButton>)
        }}

    />


    const textSx = {
        flexGrow: 1,
        background: '#F9F9FB',
        ml: {md: 4, xs: 0},
        borderRadius: "25px",
        width: "100%",
        '&.MuiOutlinedInput-root.Mui-focused fieldset': {
            borderColor: "#974EC3",

        },

    };


    if (planList?.length < 1) return <Loading/>
    return (
        <Grid sx={{
            border: {md: '1px solid #e5e0e01a', xs: 0},
            boxShadow: {md: 'rgba(17, 17, 26, 0.1) 0px 0px 16px', xs: 0},
            m: {md: 5, xs: 0},
            p: {md: 3, xs: 0},
            minHeight: "90%"
        }}>
            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, alignItems: "center", mt: 3}}>
                <Typography sx={{marginRight: "auto", my: {md: 0, xs: 1}, minWidth: '65px'}}>عنوان اول</Typography>
                <OutlinedInput sx={textSx} value={eventData?.title1 ?? ""}
                               onChange={e => setEventData({...eventData, title1: e?.target?.value})}/>
            </Grid>

            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, alignItems: "center", my: 3}}>
                <Typography sx={{marginRight: "auto", my: {md: 0, xs: 1}, minWidth: '65px'}}>عنوان دوم</Typography>
                <OutlinedInput sx={textSx} value={eventData?.title2 ?? ""}
                               onChange={e => setEventData({...eventData, title2: e?.target?.value})}/>
            </Grid>

            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, alignItems: "center", my: 3}}>
                <Typography sx={{marginRight: "auto", my: {md: 0, xs: 1}, minWidth: '65px'}}>تاریخ</Typography>
                <OutlinedInput sx={textSx} inputProps={{className: 'fa-num'}}
                               endAdornment={calendarUi} value={eventData?.start_date ?? ''}
                               onChange={e => setEventData(({...eventData, start_date: e?.target.value}))}/>
            </Grid>

            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, alignItems: "center", my: 3}}>
                <Typography sx={{marginRight: "auto", my: {md: 0, xs: 1}, minWidth: '65px'}}>برنامه</Typography>
                <Selected items={planList}
                          defaultValue={eventData?.plan_id ?? "0"}
                          value={"id"}
                          title={"name"}
                          style={{borderRadius: '50px'}}
                          sx={{
                              flexGrow: 1,
                              background: '#F9F9FB',
                              ml: {md: 4, xs: 0},
                              borderRadius: "25px",
                              width: "100%",
                          }}
                          onChangeFunction={(e) => {
                              setEventData({...eventData, plan_id: e?.target?.value})
                          }}/>
            </Grid>

            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, my: 3}}>
                <Typography sx={{mb: {md: 0, xs: 1}, minWidth: '65px'}}>توضیحـات</Typography>
                <TextInput multiline={true} value={fixStringToTextView(eventData?.description) ?? ''}
                           onChange={e => setEventData(({...eventData, description: e?.target.value}))}
                           id="outlined-multiline-flexible"
                           inputProps={{sx: {minHeight: 300}}}/>
            </Grid>

            <MyDivider sx={{my: 5}}/>

            <>
                {imageToDelete !== null &&
                    <ImageDeleteModal open={true} close={() => setImageToDelete(null)}/>}
                <FlexGrid gap={0.5} height={'auto'} sx={{
                    flexDirection: {md: "row", xs: "column"},
                    height: "300px",
                    maxWidth: '800px',
                    mx: 'auto'
                }}>

                    <Grid className={'parent-div'} sx={{
                        height: {md: "100%", xs: "100%"},
                        width: {md: '100%', xs: "100%"},
                        borderRadius: "8px",
                        position: 'relative',
                        overflow: 'hidden',
                        cursor: 'pointer'

                    }} border={'1px solid #5222ac'}>
                        {image4 === null && <Grid onClick={() => imageBrowser4?.browseForFile()}
                                                  sx={{width: '100%', height: '100%', bgcolor: '#592EA92E'}}/>}
                        {<img style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: image4 === null ? 'none' : 'block'
                        }}
                              onClick={() => imageBrowser4?.browseForFile()} ref={imageRef4} src={item?.image_url}
                              alt={'Browse for file'}/>
                        }
                        {imageBrowser4?.components}
                        <Grid sx={{
                            position: 'absolute',
                            display: "flex",
                            gap: 1,
                            justifyContent: "flex-end",
                            right: 0,
                            bottom: 0,
                            mr: 1
                        }}>
                            <AddPhotoAlternateIcon sx={{mr: 1, color: "#592EA9", cursor: "pointer"}}
                                                   onClick={() => imageBrowser4?.browseForFile()}/>
                            <DeleteIcon
                                onClick={() => setImage4(null)}
                                sx={{color: "#592EA9"}}/>
                        </Grid>

                    </Grid>

                    <Stack flexGrow={1} gap={0.2} sx={{
                        display: 'none',
                        width: {xs: "100%", md: "50%"},
                        height: {xs: "60%", md: "100%"},
                        '.parent-div': {
                            borderRadius: "8px",
                            minHeight: {md: "200px"},
                            border: '1px solid #5222ac',
                            height: {md: "200px", xs: "120px"},
                            overflow: 'hidden',
                            cursor: "pointer"
                        }
                    }}>
                        <Grid className={'parent-div'} sx={{position: 'relative'}}>
                            {image1 === null && <Grid onClick={() => imageBrowser1?.browseForFile()}
                                                      sx={{width: '100%', height: '100%', bgcolor: '#592EA92E'}}/>}
                            {<img style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: image1 === null ? 'none' : 'block'
                            }}
                                  onClick={() => imageBrowser1?.browseForFile()} ref={imageRef1} src={null}
                                  alt={'Browse for file'}/>
                            }
                            {imageBrowser1?.components}
                            <Grid sx={{
                                position: 'absolute',
                                display: "flex",
                                gap: 1,
                                justifyContent: "flex-end",
                                right: 0,
                                bottom: 0,
                                mr: 1
                            }}>
                                <AddPhotoAlternateIcon sx={{mr: 1, color: "#592EA9", cursor: "pointer"}}
                                                       onClick={() => imageBrowser1?.browseForFile()}/>
                                <DeleteIcon onClick={() => {

                                    setImageToDelete(Object.assign({}, image1))
                                }}
                                            sx={{color: "#592EA9"}}/>
                            </Grid>
                        </Grid>


                        <Grid className={'parent-div'} sx={{position: 'relative'}}>
                            {image2 === null && <Grid onClick={() => imageBrowser2?.browseForFile()}
                                                      sx={{width: '100%', height: '100%', bgcolor: '#592EA92E'}}/>}
                            {<img style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: image2 === null ? 'none' : 'block'
                            }}
                                  onClick={() => imageBrowser2?.browseForFile()} ref={imageRef2} src={null}
                                  alt={'Browse for file'}/>
                            }
                            {imageBrowser2?.components}
                            <Grid sx={{
                                position: 'absolute',
                                display: "flex",
                                gap: 1,
                                justifyContent: "flex-end",
                                right: 0,
                                bottom: 0,
                                mr: 1
                            }}>
                                <AddPhotoAlternateIcon sx={{mr: 1, color: "#592EA9", cursor: "pointer"}}
                                                       onClick={() => imageBrowser2?.browseForFile()}/> <DeleteIcon
                                onClick={() => setImage2(null)}
                                sx={{color: "#592EA9"}}/>
                            </Grid>
                        </Grid>


                        <Grid className={'parent-div'} sx={{position: 'relative'}}>
                            {image3 === null && <Grid onClick={() => imageBrowser3?.browseForFile()}
                                                      sx={{width: '100%', height: '100%', bgcolor: '#592EA92E'}}/>}
                            {<img style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: image3 === null ? 'none' : 'block'
                            }}
                                  onClick={() => imageBrowser3?.browseForFile()} ref={imageRef3} src={null}
                                  alt={'Browse for file'}/>
                            }
                            {imageBrowser3?.components}
                            <Grid sx={{
                                position: 'absolute',
                                display: "flex",
                                gap: 1,
                                justifyContent: "flex-end",
                                right: 0,
                                bottom: 0,
                                mr: 1
                            }}>
                                <AddPhotoAlternateIcon sx={{mr: 1, color: "#592EA9", cursor: "pointer"}}
                                                       onClick={() => imageBrowser3?.browseForFile()}/> <DeleteIcon
                                onClick={() => setImage3(null)}
                                sx={{color: "#592EA9"}}/>
                            </Grid>
                        </Grid>
                    </Stack>
                </FlexGrid>
            </>

            <Grid sx={{textAlign: "center", mt: 3}}>
                <Button onClick={onSubmitHandler}
                        sx={{background: "#592EA9", padding: {sm: '15px 100px', xs: '8px 80px'}, borderRadius: "30px"}}
                        variant={"contained"}>
                    ثبت تغییرات
                </Button>
            </Grid>


        </Grid>
    );
};

export default Event;